"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (injectedData) => (to, from, next) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if ((_b = (_a = to.meta) === null || _a === void 0 ? void 0 : _a.middleware) === null || _b === void 0 ? void 0 : _b.length) {
        const arr = to.meta.middleware;
        for (let index = 0; index < arr.length; index++) {
            const method = arr[index];
            const result = yield method(Object.assign(Object.assign({}, injectedData), { to, from, next }));
            if (result === false) {
                break;
            }
        }
        return;
    }
    return next();
});
